import React, { useEffect, useState } from "react";
import Logo from "../../Assets/IconSVG/SolidarityLogo.svg";
import { useLocation } from "react-router-dom";
import { GetChargeDetails } from "./API/PaymentServices";
const Invoice = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const id = params.get("id");
  const quote = params.get("quote");
  const chargeId = params.get("tap_id");

  const [loading, setLoading] = useState(false);

  const [chargeData, setChargeData] = useState(null);

  useEffect(() => {
    if (chargeId) {
      GetChargeDetails(chargeId, setLoading).then((data) => {
        if (data) setChargeData(data);
      });
    }
  }, [chargeId]);

 return (
  <div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
    {loading ? (
      <div className="w-full max-w-5xl bg-white p-8 shadow-lg rounded-lg animate-pulse space-y-6">
        {/* Skeleton Header */}
        <div className="flex justify-between items-center border-b pb-4">
          <div>
            <div className="h-6 bg-gray-300 rounded w-48 mb-2"></div>
            <div className="h-4 bg-gray-200 rounded w-32"></div>
          </div>
          <div className="h-10 w-28 bg-gray-300 rounded"></div>
        </div>

        {/* Skeleton Policy Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <div className="h-4 bg-gray-300 rounded w-24"></div>
            <div className="h-4 bg-gray-200 rounded w-40"></div>
            <div className="h-4 bg-gray-200 rounded w-36"></div>
            <div className="h-4 bg-gray-200 rounded w-48"></div>
          </div>
          <div className="space-y-2 md:text-right">
            <div className="h-4 bg-gray-300 rounded w-24 ml-auto"></div>
            <div className="h-4 bg-gray-200 rounded w-32 ml-auto"></div>
          </div>
        </div>

        {/* Skeleton Table */}
        <div className="space-y-3">
          <div className="h-6 bg-gray-200 rounded w-full"></div>
          {[...Array(3)].map((_, i) => (
            <div key={i} className="h-4 bg-gray-200 rounded w-full"></div>
          ))}
        </div>

        {/* Skeleton Footer */}
        <div className="flex flex-col md:flex-row justify-between border-t pt-4 space-y-4 md:space-y-0">
          <div className="h-4 bg-gray-200 rounded w-64"></div>
          <div className="h-6 bg-gray-300 rounded w-32"></div>
        </div>

        <div className="h-4 bg-gray-200 rounded w-96"></div>
      </div>
    ) : chargeData?.status === "CAPTURED" && chargeData.customer ? (
      <div className="w-full max-w-5xl bg-white p-8 shadow-lg rounded-lg">
        <header className="flex flex-col md:flex-row justify-between items-center border-b pb-4">
          <div>
            <h1 className="text-3xl font-bold">Invoice</h1>
            <p className="text-gray-500">Invoice #{quote}</p>
          </div>
          <div className="text-center md:text-right mt-4 md:mt-0">
            <img
              src={Logo}
              alt="Solidarity Logo"
              className="h-10 max767:flex max767:order-1 max767:mb-2"
            />
          </div>
        </header>

        <section className="mt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <h3 className="font-semibold">Policy Holder:</h3>
              <p className="text-gray-600">
                {chargeData.customer.fname} {chargeData.customer.lname}
              </p>
            </div>
            <div className="text-center md:text-right">
              <h3 className="font-semibold">Invoice Date:</h3>
              <p className="text-gray-600">
                {new Date(chargeData.createdDate).toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })}
              </p>
            </div>
          </div>
        </section>

     <table className="w-full table-fixed mt-6 border-collapse border border-gray-200 text-xs sm:text-sm md:text-base">
  <thead>
    <tr className="bg-gray-100">
      <th className="border border-gray-200 px-2 sm:px-4 py-2 text-left break-words">
        Payment Reference Number
      </th>
      <th className="border border-gray-200 px-2 sm:px-4 py-2 text-right break-words">
        Transaction ID
      </th>
      <th className="border border-gray-200 px-2 sm:px-4 py-2 text-right break-words">
        Authorization Code
      </th>
      <th className="border border-gray-200 px-2 sm:px-4 py-2 text-right break-words">
        Payment Method
      </th>
      <th className="border border-gray-200 px-2 sm:px-4 py-2 text-right break-words">
        Payment Date
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="border border-gray-200 px-2 sm:px-4 py-2 break-words">
        {quote}
      </td>
      <td className="border border-gray-200 px-2 sm:px-4 py-2 text-right break-words">
        {chargeData.receiptId}
      </td>
      <td className="border border-gray-200 px-2 sm:px-4 py-2 text-right break-words">
        {chargeData.authCode}
      </td>
      <td className="border border-gray-200 px-2 sm:px-4 py-2 text-right break-words">
        {chargeData.paymentMethod}
      </td>
      <td className="border border-gray-200 px-2 sm:px-4 py-2 text-right break-words">
        {new Date(chargeData.transactionDate).toLocaleString("en-US", {
          year: "numeric",
          month: "long",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })}
      </td>
    </tr>
  </tbody>
</table>



        <div className="flex flex-col md:flex-row justify-between mt-6 border-t pt-4 text-center md:text-left">
          <p className="text-gray-600">
            Thank you for choosing Solidarity Bahrain.
          </p>
          <div className="text-center md:text-right mt-4 md:mt-0">
            <h3 className="font-semibold">Total: BHD {chargeData.amount}</h3>
          </div>
        </div>

        <div className="f">
          <p className="text-gray-600">
            For support and further information please call 1713 0000
          </p>
        </div>
      </div>
    ) : chargeData?.status === "DECLINED" ? (
      <div className="bg-white max-w-md p-8 shadow-lg rounded-lg text-center">
        <h1 className="text-2xl font-bold text-red-600">Payment Declined</h1>
        <p className="text-gray-600 mt-4">
          Unfortunately, the payment was declined. Please try again or contact our support team at <strong>1713 0000</strong>.
        </p>
      </div>
    ) : (
      <div className="text-center text-gray-500">
        No data found or payment status is unsupported.
      </div>
    )}
  </div>
);

};

export default Invoice;
